import { Add, People } from "@mui/icons-material";
import { Button } from "@mui/material";
import { T } from "components/util/t";
import { createTeamEntry, getRegisteredEntriesByDivision, getRegisteringEntriesByDivision } from "./SelectDivisionDialog";
import { TeamRegistrationTeamCard } from "./TeamRegistrationTeamCard";
import { RegisteredTeam } from "./RegisteredTeam";
import { useWatch } from "react-hook-form";

export const getTeamName = (entryName, eventTeam) => entryName?.replace(eventTeam, "").trim().split(" - ")[0];

export const TeamRegistrationForm = ({ index, control, entry, options: divisions, athletes, formAthletes, updateAthlete, removeAthlete, appendAthlete }) => {
    const division = divisions.find(option => option.optionId === entry[0].registrations_attributes[0].option_id);
    const eventTeam = useWatch({ name: "team.name", control });

    const registered = getRegisteredEntriesByDivision(athletes, division.optionId);
    const registering = getRegisteringEntriesByDivision(formAthletes, division.optionId);

    const addTeam = () => appendAthlete(createTeamEntry(eventTeam, registered, registering, division), index);

    const membersInTeamsSameDivision = [...registered, ...registering].reduce((members, entry) => {
        if (entry.id) entry.registrations_attributes[0].team_members.forEach(member => members.id[member.athlete_id] = entry.name);
        else entry.team_members.forEach(member => member.athlete_id ? members.id[member.athlete_id] = entry.name : members.name[member.name] = entry.name);
        return members;
    }, { id: {}, name: {} });

    const options = [...athletes, ...formAthletes.reduce((newAthlete, athlete) => {
        if (athlete.team_members) athlete.team_members?.forEach(member => !member.athlete_id && !newAthlete.find(a => a.name === member.name) && newAthlete.push(member));
        else !athlete.id && !newAthlete.find(a => a.name === athlete.name) && newAthlete.push(athlete);
        return newAthlete;
    }, [])].map(athlete => {
        const entryName = membersInTeamsSameDivision.id[athlete.id] || membersInTeamsSameDivision.name[athlete.name];
        return ({
            label: athlete.name,
            value: athlete.id || athlete.name,
            disabled: !!entryName,
            message: getTeamName(entryName, eventTeam),
            icon: People,
        });
    });

    return (
        <>
            {registered.map(e =>
                <RegisteredTeam
                    key={e.name}
                    entry={e}
                    divisionId={division.optionId}
                    eventTeam={eventTeam}
                />
            )}

            {entry.map(e => (
                <TeamRegistrationTeamCard
                    key={e.name}
                    entry={e}
                    division={division}
                    options={options}
                    formAthletes={formAthletes}
                    athletes={athletes}
                    registered={registered}
                    registering={registering}
                    eventTeam={eventTeam}
                    updateAthlete={updateAthlete}
                    removeAthlete={removeAthlete}
                />
            ))}

            <Button startIcon={<Add/>} onClick={addTeam}>
                <T>Add team</T>
            </Button>
        </>
    );
};
